import { marker as bitfToTranslate } from '@biesbjerg/ngx-translate-extract-marker';
import { BITF_VALIDATION_MESSAGES } from '@bitf/constants';
import { CONSTANTS as COMMON_CONSTANTS } from '@common/constants/common.constants';
import { EBookletStatus } from '@common/enums';
import { BitfMatOkCancelDialogComponent } from '@common/libs/bitforce/core/components/ui/ok-cancel-dialog/material/bitf-mat-ok-cancel-dialog.component';
import { BitfOption } from '@common/libs/bitforce/core/models';

export const WEB_CONSTANTS = {
  fullScreenMessageComponent: null,
  okCancelDialogComponent: BitfMatOkCancelDialogComponent,
  VALIDATION_MESSAGES: {
    ...BITF_VALIDATION_MESSAGES,
  },
};

export const CONSTANTS = Object.assign(COMMON_CONSTANTS, WEB_CONSTANTS);

// All prices are without VAT
export const CASADOC_PRICES = {
  REQUESTS_FOR_DEED_OF_ORIGIN_PRICE: 65,
  SECRETARY_PRICE_PER_BOOKLET: 35,
  ACCOUNT_PRICE_PER_BOOKLET: 75,
  CASADOC_APE_PRICE: 30, // In the booklet there is the sum of casadoc and surveyor APE prices
  CASADOC_EXTRA_PERCENTAGE: 0.25, // This is the percentage applied to
  // the total price of the extra specified in the booklet for casadoc
  AGENCY_EXTRA_PERCENTAGE: 0.05, // This is the percentage applied the total
  // price of the extra specified in the booklet for the agency
};

export const BOOKLET_STATUS_OPTIONS = [
  { id: EBookletStatus.NEW, label: bitfToTranslate('COMMON.BOOKLET.STATUS.NEW') },
  { id: EBookletStatus.DUE_DILIGENCE, label: bitfToTranslate('COMMON.BOOKLET.STATUS.DUE_DILIGENCE') },
  { id: EBookletStatus.DOC_READY, label: bitfToTranslate('COMMON.BOOKLET.STATUS.DOC_READY') },
  { id: EBookletStatus.ARCHIVED, label: bitfToTranslate('COMMON.BOOKLET.STATUS.ARCHIVED') },
  { id: EBookletStatus.INACTIVE, label: bitfToTranslate('COMMON.BOOKLET.STATUS.INACTIVE') },
  { id: EBookletStatus.AUTO, label: bitfToTranslate('COMMON.BOOKLET.STATUS.AUTO') },
] as BitfOption[];

export const DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING = '2026-06-01T00:00:00Z';
export const DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING_END = `${new Date().getFullYear()}-${(new Date().getMonth() + 1).toString().padStart(2, '0')}-${new Date().getDate().toString().padStart(2, '0')}T23:59:59.999Z`;

// 20th October 2025 DATA RILASCIO Casadoc ADMIN, inizio periodo per i Todos della lista libretti admin
export const DEFAULT_DATE_FILTER_ADMIN_BOOKLETS_TODO = '2026-06-01T00:00:00Z';
